import React from 'react';
// Images
import SessionImage from '../../assets/images/main/miss-dominatrixa-elite-dominatrix-with-adult-baby.webp';
import BondageImage from '../../assets/images/main/miss-dominatrixa-elite-dominatrixa-toy-collection.webp';
import ThridImage from '../../assets/images/main/miss-dominatrixa-elite-dominatrix-with-masked-slave.webp';
import LastImage from '../../assets/images/smallGallery/miss-dominatrixa-elite-dominatrix-with-whip-small.webp';

function RealTimeMainSection() {
  return (
    <section className='container mx-auto px-6 lg:px-20 grid gap-16 mt-16'>
      {/* Real-Time Sessions */}
      <div className='grid lg:grid-cols-rev gap-8 text-center lg:text-left justify-center'>
        <div className=' my-auto'>
          <h2 className='text-xl font-bold lg:text-left text-colour3 dark:text-colour3 mb-4 font-titleFont tracking-widest border-b-2 border-solid border-colour3 dark:border-colour3 pb-1 w-fit'>
            Real-Time Domination Across Europe
          </h2>
          <p>
            Step into my world of strict control and absolute surrender. I offer
            real-time sessions across Norway and the EU in carefully selected
            locations to ensure privacy and exclusivity. Whether in a private
            dungeon, luxury hotel, or bespoke setting, each session is a fully
            immersive experience tailored to your deepest desires.
          </p>
          <p>
            Discretion is paramount, and all new clients must undergo a
            screening process before booking.
          </p>
        </div>
        <div>
          <img
            src={SessionImage}
            alt='Real-Time Domination Session'
            loading='lazy'
            className='max-h-[60vh] mx-auto rounded shadow-cardShadowBold shadow-colour3/50 dark:shadow-colour3/50'
          />
        </div>
      </div>

      {/* Bondage & Restraint Play */}
      <div className='grid lg:grid-cols-reg gap-8'>
        <div className='order-2 lg:order-1 w-full'>
          <img
            src={BondageImage}
            alt='Bondage and Restraint Play'
            loading='lazy'
            className='max-h-[60vh] mx-auto rounded shadow-cardShadowBold shadow-colour3/50 dark:shadow-colour3/50'
          />
        </div>
        <div className=' my-auto order-1 lg:order-2 text-center lg:text-left'>
          <h2 className='text-xl lg:text-left font-bold text-colour3 dark:text-colour3 mb-4 font-titleFont tracking-widest border-b-2 border-solid border-colour3 dark:border-colour3 pb-1 w-fit'>
            Bondage & Restraint Play
          </h2>
          <p>
            Escape is impossible under my skilled hands. I specialize in
            advanced restraint play, including:
          </p>
          <ul className='list-disc text-sm pl-5 space-y-2'>
            <li>Full-body bondage: Leather, rope, cuffs, and chains</li>
            <li>Custom stocks, cages, and mummification</li>
            <li>Shibari rope artistry and sensory deprivation</li>
            <li>Suspension bondage for total loss of control</li>
          </ul>
        </div>
      </div>

      {/* Discipline & Impact Play */}
      <div className='grid lg:grid-cols-2 gap-8'>
        <div className='my-auto text-center lg:text-left'>
          <h2 className='text-xl font-bold lg:text-left text-colour3 dark:text-colour3 tracking-widest border-b-2 border-solid border-colour3 dark:border-colour3 pb-1 w-fit mb-4 font-titleFont'>
            Discipline & Impact Play
          </h2>
          <p>
            My mastery of discipline will leave you trembling in submission.
            Whether you crave a light correction or severe punishment, my
            collection includes:
          </p>
          <ul className='list-disc text-sm pl-5 space-y-2'>
            <li>Canes, whips, floggers, and paddles</li>
            <li>Face slapping and humiliation training</li>
            <li>Verbal and physical discipline</li>
            <li>Forced posture training and behavioral correction</li>
          </ul>
        </div>
        <div>
          <img
            src={ThridImage}
            alt='Discipline and Impact Play'
            className='lg:max-h-[70vh] mx-auto lg:mt-6 rounded shadow-cardShadowBold shadow-colour3/50 dark:shadow-colour3/50'
          />
        </div>
      </div>

      {/* Chastity & Keyholding */}
      <div className='grid lg:grid-cols-reg gap-8'>
        <div className='order-2 lg:order-1'>
          <img
            src={SessionImage}
            alt='Chastity & Keyholding'
            loading='lazy'
            className='max-h-[60vh] rounded shadow-cardShadowBold shadow-colour3/50 dark:shadow-colour3/50'
          />
        </div>
        <div className='my-auto order-1 lg:order-2 text-center lg:text-left'>
          <h2 className='text-xl font-bold lg:text-left text-colour3 dark:text-colour3 tracking-widest border-b-2 border-solid border-colour3 dark:border-colour3 pb-1 w-fit mb-4 font-titleFont'>
            Chastity & Keyholding
          </h2>
          <p>
            I control your pleasure and denial with absolute authority. My
            chastity and keyholding services ensure you stay locked and
            obedient. Whether for short-term play or long-term commitment, my
            control is inescapable.
          </p>
          <p>
            Remote keyholding options are also available for those who wish to
            remain under my rule beyond our sessions.
          </p>
        </div>
      </div>

      {/* Sissification & Feminization */}
      <div className='grid lg:grid-cols-2 gap-8'>
        <div className='text-center lg:text-left my-auto'>
          <h2 className='text-xl font-bold lg:text-left text-colour3 dark:text-colour3 tracking-widest border-b-2 border-solid border-colour3 dark:border-colour3 pb-1 w-fit mb-4 font-titleFont'>
            Sissification & Feminization
          </h2>
          <p>
            For those who crave transformation, I offer expert guidance in
            sissification and feminization. Under my direction, you will be
            trained, dressed, and perfected to my exacting standards.
          </p>
          <ul className='list-disc text-sm pl-5 space-y-2'>
            <li>Complete wardrobe selection & transformation</li>
            <li>Behavioral training & posture correction</li>
            <li>Voice and mannerism coaching</li>
            <li>Public and private humiliation training</li>
          </ul>
        </div>
        <div>
          <img
            src={LastImage}
            alt='Sissification and Feminization'
            className='lg:max-h-[70vh] mx-auto lg:mt-6 rounded shadow-cardShadowBold shadow-colour3/50 dark:shadow-colour3/50'
          />
        </div>
      </div>
    </section>
  );
}

export default RealTimeMainSection;
